export interface FeatureSummary {
  id: number;
  token: string;
  name: string | null;
  description: string | null;
  isActive: boolean;
  clientCount: number;
  totalQuantity: number;
}

export interface MetricSummary {
  id: number;
  token: string;
  clientCount: number;
  totalQuantity: number;
}

export interface MetricPeriodPoint {
  periodStart: string;
  periodEndExclusive: string;
  totalQuantity: number;
  recordCount: number;
}

export interface MetricClientPoint {
  clientId: number;
  totalQuantity: number;
}

export interface MetricFeaturePoint {
  featureToken: string;
  totalQuantity: number;
}

export interface MetricDetail {
  id: number;
  token: string;
  totalQuantity: number;
  recordCount: number;
  clientCount: number;
  byPeriod: MetricPeriodPoint[];
  byClient: MetricClientPoint[];
  byFeature: MetricFeaturePoint[];
}

export interface ClientSummary {
  clientId: number;
  featureCount: number;
  actionCount: number;
  totalQuantity: number;
}

export type CycleType = 'None' | 'Daily' | 'Weekly' | 'Monthly' | 'Yearly';

export interface CreditEntry {
  id: number;
  clientId: number;
  magniFeatureId: number;
  featureToken: string;
  availableCredits: number;
  cycleType: CycleType | number;
  cycleStart: string | null;
  cycleResetAt: string | null;
  creditsPerCycle: number | null;
  updatedAt: string;
}

/** Mirrors UsageActionKind on the server. */
export enum UsageActionKind {
  Used = 0,
  Consume = 1,
  Revert = 2,
  Grant = 3,
}

export interface UsageActionEntry {
  id: number;
  clientId: number | null;
  magniFeatureId: number | null;
  featureToken: string | null;
  actionId: number;
  actionToken: string | null;
  kind: UsageActionKind;
  at: string;
  quantity: number;
  idempotencyKey: string | null;
  revertedAt: string | null;
  referencesActionId: number | null;
  userId: number | null;
  performedByEmail: string | null;
}

export interface ClientActionPoint {
  actionId: number;
  actionToken: string;
  usedCount: number;
  consumeCount: number;
  revertCount: number;
  totalQuantity: number;
  lastAt: string;
}

export interface ClientFeaturePoint {
  magniFeatureId: number;
  featureToken: string;
  totalQuantity: number;
  eventCount: number;
}

export interface ClientDetail {
  clientId: number;
  totalQuantity: number;
  eventCount: number;
  actionCount: number;
  featureCount: number;
  firstSeenAt: string | null;
  lastSeenAt: string | null;
  byAction: ClientActionPoint[];
  byFeature: ClientFeaturePoint[];
}

export interface PagedResult<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}
